import { useCallback, useState } from 'react';

/** Manages dialog open/close state with stable close callbacks for ViewPrompt, RegeneratePrompt, and MoreInfo dialogs */
export function usePromptDialogs() {
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [isGenerateOpen, setIsGenerateOpen] = useState(false);
  const [isMoreInfoOpen, setIsMoreInfoOpen] = useState(false);

  const openView = useCallback(() => setIsViewOpen(true), []);
  const openGenerate = useCallback(() => setIsGenerateOpen(true), []);
  const openMoreInfo = useCallback(() => setIsMoreInfoOpen(true), []);

  const closeView = useCallback(() => setIsViewOpen(false), []);
  const closeGenerate = useCallback(() => setIsGenerateOpen(false), []);
  const closeMoreInfo = useCallback(() => setIsMoreInfoOpen(false), []);

  return {
    isViewOpen,
    openView,
    closeView,
    isGenerateOpen,
    openGenerate,
    closeGenerate,
    isMoreInfoOpen,
    openMoreInfo,
    closeMoreInfo,
  } as const;
}
